const useFromSeogyo = query => {
  const { from = '' } = query;
  const isFromSeogyo = from === 'seogyo';

  return {
    isFromSeogyo,
  };
};

export default useFromSeogyo;
